import { Component } from '@angular/core';
import DataGrid from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Alliance Group';

  constructor() {
    DataGrid.defaultOptions({
      options: {
        scrolling: {
          legacyMode: true,
        },
      },
    });
  }
}
